module.exports = __webpack_public_path__ + "img/manufacture-banner-mobile.6394dace.png";